"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var react_1 = __importStar(require("react"));
var Slider_1 = __importDefault(require("@material-ui/core/Slider"));
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../lib/utils");
var ProgressSlider = function (props) { return styles_1.withStyles(function (theme) { return (__assign({}, utils_1.getSliderSizes(props.thickness, ({
    thumb: {
        color: theme.palette[props.color || 'primary'].main,
        display: props.thumb === false ? 'none' : 'block',
    },
    rail: {
        color: theme.palette[props.color || 'primary'].main,
    },
    track: {
        color: theme.palette[props.color || 'primary'].main,
    },
})))); })(Slider_1.default); };
var Progress = function (props) {
    var _a = react_1.useState(utils_1.timeToPercentage(props.time)), progress = _a[0], setProgress = _a[1];
    var PlayerProgress = ProgressSlider(props);
    react_1.useEffect(function () {
        setProgress(utils_1.timeToPercentage(props.time));
    }, [props.time]);
    var onProgressClick = function (_, value) {
        var progressValue = !Number.isFinite(value) ? 0 : value;
        setProgress(progressValue);
        props.onProgressClick(progressValue);
    };
    return (react_1.default.createElement(PlayerProgress, { value: progress, onChange: onProgressClick }));
};
exports.Progress = Progress;
//# sourceMappingURL=Progress.js.map